import { Button, Form, Input } from 'antd';
import { observer } from 'mobx-react';
import PageHeader from '../../../component/PageHeader';
import { RegionBreadrumbs } from '../../../config/BreadcrumbConfig';
import ListComponent from './components/ListComponent';
import InputComponent from '../../../component/InputComponent';
import { RegionType } from '../../../config/Global';
import useStore from '../../../store';
import { useEffect, useState } from 'react';
import AddComponent from './components/AddComponent';
import DeleteComponent from './components/DeleteComponent';
import EditComponent from './components/EditComponent';

const Region = observer(() => {
	const [userAddModal, setUserAddModal] = useState(false);
	const [userEditModal, setUserEditModal] = useState(false);
	const [userDeleteModal, setUserDeleteModal] = useState(false);
	const { REGION } = useStore();

	const AddUserModal = () => {
		setUserAddModal(true);
	};

	const closeAddModal = () => {
		setUserAddModal(false);
	};

	const openEdit = () => {
		setUserEditModal(true);
	};

	const closeEditModal = () => {
		setUserEditModal(false);
	};

	const openDelete = (data) => {
		setUserDeleteModal(data);
	};

	const closeDeleteModal = () => {
		setUserDeleteModal(false);
	};

	const onSearch = (text) => {
		if (text.length >= 3 || text.length === 0) {
			REGION.searchValue = text;
			REGION.setupGrid(REGION.agGrid);
		}
	};
	useEffect(() => {
		return () => {
			REGION.searchValue = '';
			REGION.regionType = RegionType.State;
		};
	}, []);
	const handelRegionType = (value) => {
		REGION.regionType = value;
		REGION.setupGrid(REGION.agGrid);
	};

	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={RegionBreadrumbs.title}
				extra={[
					<Form.Item help={'Write 3 letters to search'} key={1}>
						<Input
							placeholder="Search here"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Form.Item>,
					<Form.Item key={2}>
						<InputComponent
							required
							type="select"
							showSearch={true}
							name="regionType"
							placeholder="Select Region Type"
							onChange={handelRegionType}
							defaultValue={RegionType.State}
							options={{
								rejected_keys: [1, 3, 5],
								values: Object.keys(RegionType).map((key) => ({
									eRegionId: RegionType[key],
									regionName: key,
								})),
								value_key: 'eRegionId',
								text_key: 'regionName',
							}}
							style={{ width: '200px', textAlign: 'left' }}
						/>
					</Form.Item>,

					<Button
						key={2}
						type="primary"
						className="addBtn"
						onClick={AddUserModal}
					>
						Add Region
					</Button>,
				]}
			/>
			<ListComponent
				openEditModal={openEdit}
				openDeleteModal={openDelete}
			/>
			<AddComponent visible={userAddModal} onClose={closeAddModal} />
			<EditComponent visible={userEditModal} onClose={closeEditModal} />
			<DeleteComponent
				visible={userDeleteModal}
				onClose={closeDeleteModal}
			/>
		</div>
	);
});

export default Region;
